import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import Linkify from 'react-linkify';
import { connect } from 'react-redux';
import { MerchantBookingStatus } from '../../../../../interfaces/merchants/bookings';
import * as I from '../../../../../interfaces/merchants/resources/books';
import Button, { ButtonSize } from '../../../../common/buttons/Button';
import RichViewer from '../../../../common/editors/RichViewer';
import StringUtils from '../../../../utils/StringUtils';
import BookingWithPageDetailImage from './BookingWithPageDetailImage';

import css from './BookingErrorPage.module.scss';

interface StateProps {
  nickname: string;
  name: string;
  status: MerchantBookingStatus;
  coverContentsType: string;
  primaryImage?: {
    meta: {
      width: number;
      height: number;
    };
    thumb?: {
      url: string;
    };
  };
  coverContent?: {
    url: string;
    embed: string;
    thumbnailUrl: string;
  };
  isJsonDescription: boolean;
  description?: string;
  descriptionText?: string;
}

interface Props {
  withExpressFlow: boolean;
}

const BookingErrorPage = (props: StateProps & Props & InjectedIntlProps) => {
  return (
    <div className={css.BookingErrorPage}>
      <div className={css.BookingErrorPage__ErrorMessage}>
        {props.intl.formatMessage({
          id: 'books.bookingErrorPage.errorMessage.closed',
        })}
      </div>
      <div className={css.BookingErrorPage__ContentSection}>
        {props.withExpressFlow && (
          <>
            <div className={css.BookingErrorPage__Heading}>
              <div className={css.BookingErrorPage__Title}>{props.name}</div>
            </div>
            <div className={css.BookingErrorPage__Thumbnail}>
              {props.coverContentsType === 'upload_image' &&
                props.primaryImage && (
                  <BookingWithPageDetailImage
                    name={props.name}
                    primaryImage={props.primaryImage}
                  />
                )}
              {props.coverContentsType === 'embed' &&
                props.coverContent &&
                props.coverContent.embed && (
                  <div
                    className={css.BookingErrorPage__Embed}
                    dangerouslySetInnerHTML={{
                      __html: props.coverContent.embed,
                    }}
                  />
                )}
            </div>
            <div className={css.BookingErrorPage__Description}>
              {props.isJsonDescription && props.description ? (
                <RichViewer value={props.description} />
              ) : (
                props.descriptionText && (
                  <Linkify>
                    {StringUtils.simpleFormat(props.descriptionText)}
                  </Linkify>
                )
              )}
            </div>
          </>
        )}
        {!props.withExpressFlow && (
          <div className={css.BookingErrorPage__ButtonSection}>
            <Button
              isGhost={true}
              isFull={true}
              buttonSize={ButtonSize.Medium}
              href={`/${props.nickname}`}
            >
              {props.intl.formatMessage({
                id: 'books.bookingErrorPage.backToMainPage',
              })}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateProps = ({
  merchantsResourcesBooks,
}: {
  merchantsResourcesBooks: I.State;
}): StateProps => ({
  ...merchantsResourcesBooks.merchantResource!,
});

export default connect(mapStateProps)(injectIntl(BookingErrorPage));
